import * as yup from 'yup';

export const ValidationSchema = (translate) => {

    const validEmailError: string = translate("become.partner.form.email.error");
    const validTaxNumberError: string = translate("become.partner.form.tax_number.error");
    const validCompanyNameError: string = translate("become.partner.form.company.error");

    return yup
        .object({
            customerType: yup
                .string()
                .oneOf(['PFX', 'CFX'])
                .required(),
            firstName: yup
                .string()
                .trim()
                .matches(/^\S.{0,39}$/, ' ')
                .required(''),
            lastName: yup
                .string()
                .trim()
                .matches(/^\S.{0,39}$/, ' ')
                .required(''),
            mobile: yup.object({
                input: yup
                    .string()
                    .matches(/^([0-9]{8,14})$/i, ' ')
                    .required(''),
                select: yup
                    .string()
                    .matches(/^((\+){1}([ 0-9]{1,3}))$/i, ' ')
                    .required('')
            }),
            companyName: yup
                .string()
                .when('customerType', {
                    is: 'CFX',
                    then: yup
                        .string()
                        .matches(/^\S.{0,49}$/, validCompanyNameError)
                        .required(validCompanyNameError),
                    otherwise: yup.string()
                }),
            country: yup
                .string()
                .required('Country is required'),
            taxNumber: yup
                .string()
                .when('country', {
                    is: (value) => value === 'PRT' || value === 'ESP',
                    then: yup
                        .string()
                        .matches(
                            /^([0-9]{9}|[a-zA-Z]{1}[0-9]{8}|[0-9]{8}[a-zA-Z]{1}|[a-zA-Z]{1}[0-9]{7}[a-zA-Z]{1})$/,
                            validTaxNumberError
                        )
                        .required(validTaxNumberError),
                    otherwise: yup.string()
                }),
            businessCategory: yup
                .string()
                .required(''),
            email: yup
                .string()
                .trim()
                .matches(/^(([a-zA-Z0-9!#$%&'*+-\/=?^_`{|]{1,64})([@]{1})([a-zA-Z0-9-.]{2,160})([.]{1})([a-zA-Z0-9-.]{2,24}))$/i, validEmailError)
                .required(validEmailError),
            password: yup
                .string()
                .trim()
                .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*"£^()+={}\|?><,._])(?=.*[0-9])(?=.{10,16}$)/, ' ')
                .required(''),
            terms: yup
                .boolean()
                .oneOf([true])
                .required('')
        })
        .required();
};